import { Typography } from '@mui/material';

export default function ParagraphBlock({ block }: { block: any }) {
    return (
        <Typography
            sx={{
                color: "white",
                fontSize: "clamp(16px, 2vw, 22px)",
                fontWeight: block.style === "b" ? "bold" : undefined,
                mt: 1,
                mb: 2,
                whiteSpace: "pre-wrap",
                lineHeight: 1.8,
            }}
        >
            {block.text}
        </Typography>
    );
}